import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Material UI
import { lighten, makeStyles } from '@material-ui/core/styles';
import MuiToolbar from '@material-ui/core/Toolbar';
// Core components
import Typography from 'components/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minHeight: 56,
    backgroundColor: theme.palette.background.default,
  },
  highlight: {
    color: theme.palette.primary.main,
    backgroundColor: lighten(theme.palette.primary.light, 0.85),
  },
  title: {
    flex: '1 1 100%',
  },
  actions: {
    flex: '0 0 auto',
  },
}));

const TableToolbar = ({ highlight, title, actions }) => {
  const classes = useStyles();

  return (
    <MuiToolbar
      className={
        classnames(classes.root, {
          [classes.highlight]: highlight,
        })
      }
    >
      <div className={classes.title}>
        {title && (
          <Typography type="tableToolbarTitle">
            {title}
          </Typography>
        )}
      </div>
      <div className={classes.actions}>
        {actions}
      </div>
    </MuiToolbar>
  );
};

TableToolbar.propTypes = {
  highlight: PropTypes.bool,
  title: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
};

TableToolbar.defaultProps = {
  highlight: false,
  title: null,
  actions: null,
};

export default TableToolbar;



// WEBPACK FOOTER //
// ./components/core/table/TableToolbar.js